import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import { SearchInput, Stack } from '@fashionnovateam/nova-ui-toolkit';
import { FilterTab, FilterTabProps } from '../FilterTab';

export type SubHeaderProps = React.HTMLAttributes<HTMLDivElement> & {
  children?: React.ReactNode;
  filter?: FilterTabProps<string>;
  search?: {
    value: string;
    onChange: (value: string) => void;
    maxLength?: number;
    position?: 'left' | 'right';
    placeholder?: string;
    className?: string;
  };
};

export function SubHeader({
  className,
  children,
  search,
  filter,
  ...divProps
}: SubHeaderProps) {
  const searchPosition = search?.position || 'right';
  const [searchValue, setSearchValue] = useState(search?.value || '');
  useEffect(() => {
    setSearchValue(search?.value || '');
  }, [search?.value]);
  const handleChange = (value: string) => {
    if (
      search?.maxLength &&
      value.length > search.maxLength &&
      value.length > searchValue.length
    )
      return;
    setSearchValue(value);
    search?.onChange(value);
  };

  const containerClass = cn(
    'bg-neutral-0 border-b nu-border-neutral-200 px-5 xl:px-6 py-[10px] sticky top-0 left-0 z-10 flex-wrap lg:flex-nowrap gap-3',
    className,
  );

  const searchInput = search ? (
    <SearchInput
      data-testid="search"
      value={searchValue}
      onChangeValue={handleChange}
      className={cn('grow lg:grow-0 min-w-44', search?.className)}
      placeholder={search?.placeholder || 'Search..'}
    />
  ) : null;

  return (
    <Stack
      {...divProps}
      direction="row"
      content="start"
      align="center"
      className={containerClass}
    >
      {search && searchPosition === 'left' && searchInput}
      {filter && (
        <FilterTab
          type="segment"
          onChange={filter.onChange}
          value={filter.value}
          items={filter.items}
        />
      )}
      <Stack
        direction="row"
        align="center"
        className="py-[2px] w-full lg:w-fit whitespace-nowrap lg:gap-3 gap-2"
        width="none"
      >
        {search && searchPosition === 'right' && searchInput}
        {children}
      </Stack>
    </Stack>
  );
}
